
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class RemoveListItem extends Vue {
    @Prop({ type: String, required: true }) readonly routeName!: string;
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: Number, default: undefined }) readonly count?: number;
    @Prop({ type: Object, default: undefined }) readonly routeParams?: Record<string, string>;
    @Prop({ type: Object, default: undefined }) readonly routeQuery?: Record<string, string>;

    get linkTitle(): string {
      if (!this.count) {
        return this.title;
      }

      return `${this.title} - ${ this.count }`;
    }

    redirect(): void {
      this.$emit('clicked');

      const currentRouteName = this.$route.name;

      if (currentRouteName === this.routeName) {
        return;
      }

      this.$router.push({
        name: this.routeName,
        params: this.routeParams,
        query: this.routeQuery,
      })
    }
  }
